import {useApiQuery} from 'src/hooks/useApiQuery';
import type {FilterOption} from 'src/types/byod';
import {BYOD_API_BASE as BASE} from 'src/components/analytics-genesis/byod/api';
import {byodQueryDefaults} from 'src/components/analytics-genesis/byod/api/error-handling';


type FilterOptionsResponse = {
  key: string;
  options: FilterOption[];
};

export function useFilterOptions(filterKey: string | null) {
  return useApiQuery<FilterOptionsResponse>(
    filterKey
      ? {pathname: `${BASE}/filters/${encodeURIComponent(filterKey)}/options`}
      : null,
    {
      queryOptions: {
        ...byodQueryDefaults,
        queryKey: ['byod-filter-options', filterKey],
        enabled: Boolean(filterKey),
        staleTime: 30 * 1000,
        gcTime: 60 * 1000,
      },
    },
  );
}
